<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const localProps = defineProps({
  size: { type: String, required: false, default: 'is-small' }
})

const searchText = ref('')
const router = useRouter()
const onSearch = () => {
  router.push({ name: 'clinician-lookup', query: { search: searchText.value } })
  searchText.value = ''
}
</script>
<template>
  <b-field class="navbar-search">
    <b-input
      v-model="searchText"
      expanded
      :size="localProps.size"
      :placeholder="$t('clinician-lookup-placeholder')"
      @keyup.enter="onSearch"
    />
    <p class="control">
      <b-button type="is-primary" :size="localProps.size" icon-left="search" @click="onSearch" />
    </p>
  </b-field>
</template>
